import { Injectable } from '@angular/core';

import { NecLoadingConfig } from './loading-config';

@Injectable()
export class NecLoadingService {
  getNecLoadingConfig() {
    return new NecLoadingConfig();
  }
}
